export const lunchTypes = [
    { "id": "1", "title": "Deli Sandwich", "isActive": 1 },
    { "id": "2", "title": "Vegetarian", "isActive": 1 },
    { "id": "3", "title": "Gluten Free", "isActive": 1 }
]